import axios from "axios";

const isIo = window.location.hostname.split(".").pop() === "io";

const axiosInstance = axios.create({
  baseURL:
    (isIo ? process.env.REACT_APP_API_URL_IO : process.env.REACT_APP_API_URL) ||
    "http://localhost:5000/api",
  withCredentials: true,
});

export default axiosInstance;
